const KeenSlider = window.KeenSlider

const { useAutoplay } = window.BAO.Carousel.plugins

class AnnouncementBar extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setHeight()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.setHeight = this.setHeight.bind(this)

    window.addEventListener('resize', this.setHeight)
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [useAutoplay(4, { pauseOnHover: true })],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }

  setHeight () {
    document.documentElement.style.setProperty(
      '--Header_TopBar',
      `${this.offsetHeight}px`,
    )
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
